"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abis = void 0;
const types_1 = require("../types");
const Bid_1 = require("./Bid");
const BidV2_1 = require("./BidV2");
const CollectionFactory_1 = require("./CollectionFactory");
const CollectionManager_1 = require("./CollectionManager");
const CollectionStore_1 = require("./CollectionStore");
const Committee_1 = require("./Committee");
const ERC20_1 = require("./ERC20");
const ERC721_1 = require("./ERC721");
const ERC721CollectionV2_1 = require("./ERC721CollectionV2");
const Forwarder_1 = require("./Forwarder");
const MANAToken_1 = require("./MANAToken");
const Marketplace_1 = require("./Marketplace");
const MarketplaceV2_1 = require("./MarketplaceV2");
const Rarities_1 = require("./Rarities");
const Tiers_1 = require("./Tiers");
const ThirdPartyRegistry_1 = require("./ThirdPartyRegistry");
const ChainlinkOracle_1 = require("./ChainlinkOracle");
const RaritiesWithOracle_1 = require("./RaritiesWithOracle");
const CollectionFactoryV3_1 = require("./CollectionFactoryV3");
const Rentals_1 = require("./Rentals");
const DCLRegistrar_1 = require("./DCLRegistrar");
const DCLController_1 = require("./DCLController");
const DCLControllerV2_1 = require("./DCLControllerV2");
exports.abis = {
    [types_1.ContractName.Bid]: Bid_1.Bid,
    [types_1.ContractName.BidV2]: BidV2_1.BidV2,
    [types_1.ContractName.CollectionFactory]: CollectionFactory_1.CollectionFactory,
    [types_1.ContractName.CollectionFactoryV3]: CollectionFactoryV3_1.CollectionFactoryV3,
    [types_1.ContractName.CollectionManager]: CollectionManager_1.CollectionManager,
    [types_1.ContractName.CollectionStore]: CollectionStore_1.CollectionStore,
    [types_1.ContractName.Committee]: Committee_1.Committee,
    [types_1.ContractName.ERC20]: ERC20_1.ERC20,
    [types_1.ContractName.ERC721]: ERC721_1.ERC721,
    [types_1.ContractName.ERC721CollectionV2]: ERC721CollectionV2_1.ERC721CollectionV2,
    [types_1.ContractName.Forwarder]: Forwarder_1.Forwarder,
    [types_1.ContractName.MANAToken]: MANAToken_1.MANAToken,
    [types_1.ContractName.Marketplace]: Marketplace_1.Marketplace,
    [types_1.ContractName.MarketplaceV2]: MarketplaceV2_1.MarketplaceV2,
    [types_1.ContractName.Rarities]: Rarities_1.Rarities,
    [types_1.ContractName.RaritiesWithOracle]: RaritiesWithOracle_1.RaritiesWithOracle,
    [types_1.ContractName.ThirdPartyRegistry]: ThirdPartyRegistry_1.ThirdPartyRegistry,
    [types_1.ContractName.Tiers]: Tiers_1.Tiers,
    [types_1.ContractName.ChainlinkOracle]: ChainlinkOracle_1.ChainlinkOracle,
    [types_1.ContractName.Rentals]: Rentals_1.Rentals,
    [types_1.ContractName.DCLRegistrar]: DCLRegistrar_1.DCLRegistrar,
    [types_1.ContractName.DCLController]: DCLController_1.DCLController,
    [types_1.ContractName.DCLControllerV2]: DCLControllerV2_1.DCLControllerV2
};
//# sourceMappingURL=index.js.map